import * as React from "react";
import * as styles from "./color-picker.css";
import { ChromePicker } from "react-color";
import { useState, useEffect, useRef } from "react";
import { actionCreators } from "page/calendar/store";
import { actionCreators as burdeApiContentActionCreators } from "burde-api-content/store";
import { connect } from "react-redux";

type ColorPickerProps = {
    colors: Array<string>;
    selectedColor: string | null;
    useCustomColorPicker: boolean;
    backCover: boolean | null;
} & typeof actionCreators &
    typeof burdeApiContentActionCreators;

const ColorPicker = ({
    colors,
    selectedColor,
    updateCoverImageId,
    updateCoverColor,
    updateCustomCoverImageId,
    updateBackCoverImageId,
    updateBackCoverColor,
    updateCustomBackImageId,
    useCustomColorPicker,
    backCover,
}: ColorPickerProps) => {
    const [showCustomColorPicker, setShowCustomColorPicker] = useState(false);
    const ref: any = useRef();

    const changeColor = (color: string | null) => {
        if (backCover) {
            updateBackCoverImageId(null);
            updateBackCoverColor(color);
            updateCustomBackImageId(null);
        } else {
            updateCoverImageId(null);
            updateCoverColor(color);
            updateCustomCoverImageId(null);
        }
    };

    const getCustomColorSelected = (
        selectedColor: string | null,
        colors: string[],
    ) => {
        if (!selectedColor) {
            return false;
        }

        return !colors.includes(selectedColor);
    };

    const handleClickOutside = (e: any) => {
        if (ref.current !== undefined && !ref.current.contains(e.target)) {
            setShowCustomColorPicker(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div
            className={styles.colorPickerContainer}
            onBlur={() => {
                setShowCustomColorPicker(false);
            }}>
            <ul className={styles.colorPicker}>
                {colors.map((color, index) => (
                    <li className={styles.colorPickerListItem} key={index}>
                        <div
                            onClick={() => {
                                changeColor(
                                    color !== selectedColor
                                        ? color
                                        : "rgb(255, 255, 255)",
                                );
                            }}
                            className={`${styles.colorPickerItem} ${
                                color === selectedColor
                                    ? styles.colorPickerItemSelected
                                    : ""
                            }`}
                            style={{ backgroundColor: color }}
                        />
                    </li>
                ))}
                {useCustomColorPicker && (
                    <li className={styles.colorPickerListItem}>
                        <div
                            style={{
                                backgroundImage:
                                    "url(images/color-palette.svg)",
                                border: "0",
                            }}
                            onClick={() =>
                                setShowCustomColorPicker(!showCustomColorPicker)
                            }
                            className={`${styles.colorPickerItem} ${
                                getCustomColorSelected(selectedColor, colors)
                                    ? styles.colorPickerItemSelected
                                    : ""
                            }`}
                        />
                    </li>
                )}
            </ul>
            {showCustomColorPicker && (
                <div ref={ref} className={styles.customColorPickerContainer}>
                    <div className={styles.customColorPicker}>
                        <i
                            className={"fas fa-times"}
                            onClick={() => {
                                setShowCustomColorPicker(false);
                            }}
                        />
                    </div>
                    <ChromePicker
                        color={
                            selectedColor ? selectedColor : "rgb(255, 255, 255)"
                        }
                        onChangeComplete={(color: any) => {
                            if (color) {
                                changeColor(color.hex);
                            }
                        }}
                        disableAlpha={true}
                    />
                </div>
            )}
        </div>
    );
};

const mapDispatchToProps = {
    ...actionCreators,
    ...burdeApiContentActionCreators,
};

export default connect(null, mapDispatchToProps)(ColorPicker);
